(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["maxcom-offers"] && !Shopify.designMode) return;
  try {
    
(function(){
function init(){
const root=document.getElementById('max-offers');if(!root||root.dataset.ready)return;root.dataset.ready='true';
const grid=root.querySelector('.mof-grid'),input=root.querySelector('#mof-query'),sort=root.querySelector('[data-sort]'),status=root.querySelector('[data-status]'),empty=root.querySelector('.mof-empty'),loading=root.querySelector('.mof-loading');
let selected='all',busy=false;
const norm=s=>s.toLocaleLowerCase('bs').normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/đ/g,'dj');
function apply(){
 const terms=norm(input.value).trim().split(/\s+/).filter(Boolean);
 const cards=Array.from(grid.querySelectorAll('.mof-card'));
 cards.sort((a,b)=>sort.value==='name'?a.dataset.title.localeCompare(b.dataset.title,'bs'):Number(b.dataset.date)-Number(a.dataset.date));
 let count=0;for(const card of cards){grid.appendChild(card);const hay=norm(card.dataset.title+' '+card.dataset.handle);const show=(selected==='all'||card.dataset.categories.split(' ').includes(selected))&&terms.every(t=>hay.includes(t));card.hidden=!show;if(show)count++;}
 status.textContent=count+' / '+cards.length;empty.hidden=count>0||busy;
}
root.querySelector('.mof-search').addEventListener('submit',e=>{e.preventDefault();apply()});
input.addEventListener('input',apply);sort.addEventListener('change',apply);
root.querySelectorAll('[data-filter]').forEach(b=>b.addEventListener('click',()=>{selected=b.dataset.filter;root.querySelectorAll('[data-filter]').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));apply()}));
async function loadMore(){
 let link=root.querySelector('.mof-next');if(!link){apply();return;}
 busy=true;loading.hidden=false;
 const seen=new Set();
 try{
 while(link){
  const url=new URL(link.href,location.origin);if(url.origin!==location.origin||seen.has(url.href))break;seen.add(url.href);
  const params=new URLSearchParams(location.search);if(params.has('preview_theme_id'))url.searchParams.set('preview_theme_id',params.get('preview_theme_id'));
  url.searchParams.set('section_id',root.dataset.section);
  const response=await fetch(url.href,{credentials:'same-origin'});if(!response.ok)throw new Error('load');
  const doc=new DOMParser().parseFromString(await response.text(),'text/html');const nextRoot=doc.querySelector('#max-offers');if(!nextRoot)throw new Error('section');
  const handles=new Set(Array.from(grid.children).map(c=>c.dataset.handle));
  nextRoot.querySelectorAll('.mof-card').forEach(c=>{if(!handles.has(c.dataset.handle))grid.appendChild(c)});
  const next=nextRoot.querySelector('.mof-next');if(next){link.href=next.href}else{link.remove();link=null}apply();
 }
 }catch(e){if(link)link.hidden=false;}
 busy=false;loading.hidden=true;apply();
}
apply();loadMore();
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maxcom-product-sales"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const variants = JSON.parse(root.querySelector('[data-mxp-variants]').textContent);
    const form = root.querySelector('.mxp-form');
    const selector = form.querySelector('[name="id"]');
    const quantity = form.querySelector('[name="quantity"]');
    const mainImage = root.querySelector('.mxp-main-image');
    const lightbox = root.querySelector('.mxp-lightbox');
    const sticky = root.querySelector('.mxp-sticky');
    const stickyButton = root.querySelector('[data-sticky-order]');
    root.querySelectorAll('a[href="#' + root.querySelector('.mxp-review-form form').id + '"]').forEach(link => link.addEventListener('click', () => { root.querySelector('.mxp-review-form').open = true; }));
    const money = value => {
      if (!root.dataset.currency || root.dataset.currency === 'BAM') return 'KM ' + (value / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return new Intl.NumberFormat('bs-BA', { style: 'currency', currency: root.dataset.currency }).format(value / 100);
    };
    const selectPhoto = button => {
      if (!button || !mainImage) return;
      mainImage.removeAttribute('srcset');
      mainImage.src = button.dataset.image;
      mainImage.alt = button.dataset.alt;
      root.querySelectorAll('.mxp-thumb').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
    };
    root.querySelectorAll('.mxp-thumb').forEach(button => button.addEventListener('click', () => selectPhoto(button)));
    root.querySelector('.mxp-zoom')?.addEventListener('click', () => {
      const image = lightbox.querySelector('img');
      image.removeAttribute('srcset'); image.src = mainImage.src; image.alt = mainImage.alt;
      lightbox.showModal();
    });
    root.querySelector('.mxp-close').addEventListener('click', () => lightbox.close());
    lightbox.addEventListener('click', e => { if (e.target === lightbox) lightbox.close(); });
    const current = () => variants.find(v => String(v.id) === selector.value) || variants[0];
    const rateDialog = root.querySelector('.mxp-rate-dialog');
    const rateForm = rateDialog.querySelector('form');
    const rateButton = root.querySelector('[data-rate-open]');
    const syncRate = () => {
      const v = current();
      const qty = Math.max(v.min, Number(quantity.value) || v.min);
      const known = v.compare > v.price;
      const unit = known ? v.compare_text.replace(/<[^>]*>/g, '') : rateDialog.dataset.onRequest;
      const total = known ? money(v.compare * qty) : rateDialog.dataset.onRequest;
      root.querySelectorAll('[data-rate-unit]').forEach(el => el.textContent = unit);
      rateDialog.querySelector('[data-rate-total]').textContent = total;
      rateDialog.querySelector('[data-rate-quantity]').textContent = qty;
      rateDialog.querySelector('[data-rate-variant]').textContent = v.title === 'Default Title' ? '' : v.title;
      rateForm.querySelector('[data-rate-variant-input]').value = v.title;
      rateForm.querySelector('[data-rate-id]').value = v.id;
      rateForm.querySelector('[data-rate-price-input]').value = unit;
      rateForm.querySelector('[data-rate-qty-input]').value = qty;
      rateForm.querySelector('[data-rate-total-input]').value = total;
      rateButton.disabled = !v.available;
      rateForm.querySelector('[type="submit"]').disabled = !v.available;
    };
    rateButton.addEventListener('click', () => {
      if (!quantity.reportValidity() || !current().available) return;
      syncRate(); rateDialog.showModal();
    });
    rateDialog.querySelector('[data-rate-close]').addEventListener('click', () => rateDialog.close());
    rateDialog.addEventListener('click', e => { if (e.target === rateDialog) { const box = rateDialog.getBoundingClientRect(); if (e.clientX < box.left || e.clientX > box.right || e.clientY < box.top || e.clientY > box.bottom) rateDialog.close(); } });
    rateForm.addEventListener('submit', e => {
      syncRate();
      if (!current().available || !quantity.checkValidity()) { e.preventDefault(); return; }
      try { sessionStorage.setItem('mxp-rate-pending', location.pathname); } catch (_) {}
    });
    selector.addEventListener('change', syncRate);
    quantity.addEventListener('input', syncRate);
    syncRate();
    const updateTotal = () => {
      const v = current();
      const total = root.querySelector('[data-total]');
      if (total) total.textContent = money(v.price * (Number(quantity.value) || v.min) + Number(root.dataset.shipping));
    };
    const updateVariant = () => {
      const v = current();
      root.querySelectorAll('[data-price]').forEach(el => el.textContent = v.price_text.replace(/<[^>]*>/g, ''));
      const compare = root.querySelector('[data-compare]'); const save = root.querySelector('[data-save]');
      compare.hidden = save.hidden = !(v.compare > v.price);
      compare.textContent = v.compare_text.replace(/<[^>]*>/g, '');
      save.textContent = '−' + v.saving_text.replace(/<[^>]*>/g, '');
      root.querySelector('[data-stock]').textContent = v.available ? root.dataset.available : root.dataset.soldOut;
      const add = form.querySelector('[name="add"]'); add.disabled = !v.available;
      add.textContent = v.available ? root.dataset.addLabel : root.dataset.soldOut;
      stickyButton.disabled = !v.available; stickyButton.textContent = v.available ? root.dataset.orderLabel : root.dataset.soldOut;
      quantity.min = v.min; quantity.step = v.step;
      if (v.max) quantity.max = v.max; else quantity.removeAttribute('max');
      quantity.value = v.min;
      if (v.image_id) selectPhoto(root.querySelector('[data-image-id="' + v.image_id + '"]'));
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
      updateTotal();
      syncRate();
    };
    selector.addEventListener('change', updateVariant);
    quantity.addEventListener('input', updateTotal);
    const syncCod = () => {
      const button = root.querySelector('#rsi_buy_now_button');
      if (button) button.hidden = !current().available;
    };
    selector.addEventListener('change', syncCod);
    const observer = new MutationObserver(syncCod);
    observer.observe(form, { childList: true, subtree: true }); syncCod();
    stickyButton.addEventListener('click', () => {
      const button = root.querySelector('#rsi_buy_now_button');
      if (current().available && button && !button.disabled && !button.hidden) { button.click(); return; }
      root.querySelector('.mxp-buy-box').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});
      form.querySelector('[name="add"]').focus({preventScroll:true});
    });
    const visibility = new IntersectionObserver(entries => { sticky.hidden = entries[0].isIntersecting; }, { threshold: 0 });
    visibility.observe(root.querySelector('.mxp-buy-box'));
    let ratePending = false;
    try { ratePending = sessionStorage.getItem('mxp-rate-pending') === location.pathname; } catch (_) {}
    const returnedFromRate = new URLSearchParams(location.search).get('mxp_form') === 'rate' || location.hash === '#' + rateForm.id || ratePending;
    if (returnedFromRate && (new URLSearchParams(location.search).has('contact_posted') || rateForm.querySelector('.errors') || rateForm.querySelector('.mxp-rate-success'))) {
      rateDialog.showModal();
      try { sessionStorage.removeItem('mxp-rate-pending'); } catch (_) {}
    }
    if (!returnedFromRate && (new URLSearchParams(location.search).has('contact_posted') || root.querySelector('.mxp-review-form .errors'))) {
      const panel = root.querySelector('.mxp-review-form'); panel.open = true; panel.scrollIntoView({block:'center'});
    }
    if (new URLSearchParams(location.search).get('open-cod') === '1') {
      let attempts = 0;
      setTimeout(() => {
        const timer = setInterval(() => {
          const button = root.querySelector('#rsi_buy_now_button');
          if (button && !button.disabled && current().available) { button.click(); clearInterval(timer); }
          if (++attempts > 20) clearInterval(timer);
        }, 500);
      }, 3000);
    }
  };
  document.querySelectorAll('.mxp').forEach(init);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('.mxp').forEach(init));
})();

  } catch(e) { console.error(e); }
})();
})();
